import { Injectable } from '@angular/core';
import {
  safeLocalStorageGetItem,
  safeLocalStorageRemoveItem,
  safeLocalStorageSetItem,
} from 'src/app/utils/storage';

@Injectable({
  providedIn: 'root',
})
export class RedirectProvider {
  private redirectToStorageKey = 'redirectTo';

  setPathToRedirectTo(path: string) {
    if (path === '/' || path === '/login') {
      return;
    }
    safeLocalStorageSetItem(this.redirectToStorageKey, path);
  }

  getPathToRedirectTo() {
    const storedRedirectLocation = safeLocalStorageGetItem(this.redirectToStorageKey);
    if (storedRedirectLocation) {
      return storedRedirectLocation;
    }

    return '/';
  }

  clearPathToRedirectTo() {
    safeLocalStorageRemoveItem(this.redirectToStorageKey);
  }
}
